import StatisticsDetails from './StatisticsDetails';

export default StatisticsDetails;
